import { useQuery } from '@tanstack/react-query';
import { formBuilderApi, formBuilderKeys } from '@/features/quote-and-apply-builder';

export function useCarrierForms(insuranceCarrierId: number) {
  return useQuery({
    queryKey: formBuilderKeys.detail(String(insuranceCarrierId)),
    queryFn: () => formBuilderApi.getFormsByCarrierId(insuranceCarrierId),
  });
}
